import { MenuIcon } from "lucide-react";
import { useSidebar } from "@/_old/components/ui/sidebar";

export const SidebarToggleResponsive = () => {
  const { toggleSidebar } = useSidebar();

  const handleToggleSidebar = () => {
    toggleSidebar();
  };

  return (
    <div className="flex items-center justify-between pl-4 pt-4">
      <MenuIcon
        className="w-6 h-6 cursor-pointer"
        onClick={handleToggleSidebar}
      />
    </div>
  );
};
